const compose = require('compose-middleware').compose;

const cookieParser = require('cookie-parser');
const bodyParser = require('body-parser');


module.exports = function boringInection(boring) {

  boring.before('init-routers', function() {
    boring.app.use('parsers', boring.middleware.parsers);
  });

  return compose([
    bodyParser.json(),
    bodyParser.urlencoded({extended: false}),
    cookieParser(),
  ]);
};
